import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "24.894",
  width: "50",
  viewBox: "0 0 50 24.894",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M25 0C10.993 0 0 5.46 0 12.447c0 6.986 10.993 12.447 25 12.447s25-5.46 25-12.447C50 6.383 41.24 0 25 0zM3.582 12.41c0-4.042 8.227-8.545 20.142-8.864-4.326.638-7.695 4.36-7.695 8.865s3.33 8.23 7.69 8.87c-11.95-.284-20.14-4.79-20.14-8.866zm22.695 8.866c4.326-.638 7.695-4.36 7.695-8.865 0-1.093-.213-2.23-.674-3.292-.638.922-1.702 1.525-2.943 1.525-1.986 0-3.582-1.596-3.582-3.582 0-1.24.603-2.304 1.56-2.942-.638-.248-1.31-.425-2.056-.532 13.156.32 20.142 5.25 20.142 8.866 0 4.043-8.198 8.547-20.148 8.83z"
  })]
});